import request from 'common/request/axios';

export const AttendActivity = (data) =>
  request.post("/activity-server/invitation/add", data);
export const WXConfig = (appId) =>
  request.get(
    `/common-wechat-server/api/officialAccount/getJsapiTicket?appId=${appId}`
  );